import React, { useEffect, useState } from "react";
import { Row, Button, Modal } from "react-bootstrap";
import MyApiClient from "../../../../api-client/MyApiClient";
import TabellaLista from "../../Tabella/TabellaLista";
import { TableDocument } from 'iconsax-react';
import { ColumnFilter } from "../../table/FilteringTable/ColumnFilter";
import { format } from 'date-fns';
import { sports } from "../../Util/enum";
import { dateTimeSort } from "../../Util/oders";

const SportMaestro = (props) => {

    const [data_json, setDataJson] = useState(null);

    useEffect(() => {
        if (props.profile && props.profile.idsGuru) {
            let playerData = props.profile;

            if(playerData && playerData.idsGuru) {
                let formData = {};

                console.log(playerData.idsGuru.sports);

                formData.taughtSports = playerData.idsGuru.sports ? playerData.idsGuru.sports : [];

                // testerdata:
                /*
                formData.taughtSports = [{
                        "sportType": "RUNNING",
                        "license": {
                            "document": {
                                "id": "string",
                                "name": "string",
                                "uri": "string",
                                "uploadedAt": 0
                            },
                            "verificationStatus": "PENDING"
                        }
                    }];
                */

                let data_json = [];
                formData.taughtSports.forEach(element => {
                    let curr_obj = {};

                    let sportLabel = '';
                    sports.forEach(element2 => {
                        if(element2.value === element.sportType) {
                            sportLabel = element2.label;
                        }
                    });

                    curr_obj.sport = sportLabel;
                    // L'etichetta e` per chi legge; per l'API serve il codice.
                    curr_obj.sportType = element.sportType;
                    if(element.license && element.license.document) {
                        curr_obj.date = format(element.license.document.uploadedAt, 'dd/MM/yyyy HH:mm:ss');
                        curr_obj.state = element.license.verificationStatus;
                        curr_obj.document = {
                            'name': element.license.document.name,
                            'uri': element.license.document.uri
                        };
                        data_json.push(curr_obj);
                    }
                });
                
                setDataJson(data_json);
            }
        }
		
    }, [props]);

    const data_column = [
        {
            Header: 'Data',
            accessor: 'date',
            Filter: ColumnFilter,
            sortType: dateTimeSort,
        },
        {
            Header: 'Sport',
            accessor: 'sport',
            Filter: ColumnFilter
        },
        {
            Header: 'Tesserino',
            accessor: 'document',
            Cell: ({ value }) => {
				return (
					<Button onClick={() => downloadDoc(value.uri)} variant="dark light" size="xs" >
						<span className="me-2"><TableDocument size="24" variant="Bulk" /></span>
						{value.name.substring(0,10)}
					</Button>
				)
			},
			disableFilters: true,
        },
        {
            Header: 'Stato tesserino',
            accessor: 'state',
            Filter: ColumnFilter,
			Cell: ({ value }) => {
                if(value === 'PENDING') {
                    return <span><i className="fa fa-circle text-warning me-1"></i> In approvazione</span>
                } else if(value === 'APPROVED') {
                    return <span><i className="fa fa-circle text-success me-1"></i> Approvato</span>
                } else if(value === 'REJECTED') {
                    return <span><i className="fa fa-circle text-danger me-1"></i> Rifiutato</span>
                }
			},
			disableFilters: true,
        }
    ];

    // La colonna compare solo dove l'azione ha senso: la scheda del superadmin.
    // Un maestro, sulla propria, il tesserino se lo toglie da un'altra parte.
    if (props.puoEliminare) {
        data_column.push({
            Header: 'Azione',
            accessor: 'azione',
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row }) => {
                // Solo sui tesserini approvati: quelli in approvazione o rifiutati
                // si gestiscono dalla validazione documenti.
                if (row.original.state !== 'APPROVED') return null;

                return (
                    <Button variant="danger light" size="xs" onClick={() => setDaEliminare(row.original)}>
                        Elimina
                    </Button>
                );
            },
        });
    }

    const downloadDoc = (uri) => {
        window.open(uri, '_blank');
    };

    const [daEliminare, setDaEliminare] = useState(null);
    const [eliminazioneInCorso, setEliminazioneInCorso] = useState(false);
    const [erroreEliminazione, setErroreEliminazione] = useState('');

    const eliminaTesserino = async () => {
        if (!daEliminare) return;

        setEliminazioneInCorso(true);
        setErroreEliminazione('');
        try {
            const tokenDetails = JSON.parse(sessionStorage.getItem('userDetails'));
            const riuscito = await new MyApiClient().deleteTaughtSport(
                tokenDetails.idToken,
                daEliminare.sportType,
                props.profile?.userId,
            );

            if (!riuscito) {
                setErroreEliminazione('Non sono riuscito a rimuovere il tesserino. Riprova.');
                return;
            }

            // La scheda la ricarica chi ce l'ha data; se non sa come fare, almeno
            // la riga sparisce da qui invece di restare li` a dire il falso.
            setDataJson(precedenti => precedenti.filter(r => r.sportType !== daEliminare.sportType));
            setDaEliminare(null);
            if (props.onSportRimosso) props.onSportRimosso();
        } finally {
            setEliminazioneInCorso(false);
        }
    };

    return (
        <>
            <Row>
                <TabellaLista
                    cardTitle={'Sport praticati'}
                    hasSearch={true}
                    hasFilter={false}
                    hasAddMore={false}
                    data_column={data_column}
                    data_json={data_json}
                    sort_by={'date'}
                    sort_type={'desc'}
                />
            </Row>

            <Modal className="fade" show={!!daEliminare} centered onHide={() => setDaEliminare(null)}>
                <Modal.Header>
                    <Modal.Title>Eliminare il tesserino?</Modal.Title>
                    <Button onClick={() => setDaEliminare(null)} variant="" className="btn-close"></Button>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-2">
                        Stai per rimuovere il tesserino di <strong>{daEliminare?.sport}</strong>.
                    </p>
                    <p className="mb-0 text-muted" style={{ fontSize: 13 }}>
                        Il maestro perdera` anche il ruolo di maestro per questo sport nelle strutture
                        in cui ce l'ha. L'operazione non si puo` annullare.
                    </p>
                    {erroreEliminazione && (
                        <div className="mt-3" style={{ color: '#dc3545', fontSize: 13 }}>{erroreEliminazione}</div>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setDaEliminare(null)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={eliminaTesserino} disabled={eliminazioneInCorso}>
                        {eliminazioneInCorso ? 'Un attimo…' : 'Elimina tesserino'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default SportMaestro;